// AboutUs.jsx
import { Fragment } from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  Stack,
  Chip,
  Divider,
  Button,
  Avatar,
  IconButton,
} from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import AutoFixHighRoundedIcon from "@mui/icons-material/AutoFixHighRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import FavoriteBorderRoundedIcon from "@mui/icons-material/FavoriteBorderRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

export default function AboutUs() {
  return (
    <Fragment>
      {/* Hero — luxury gradient + soft shapes */}
      <Box
        component="section"
        sx={{
          position: "relative",
          overflow: "hidden",
          py: { xs: 8, sm: 10, md: 12 },
          background:
            "radial-gradient(1200px 500px at 10% 0%, rgba(255, 192, 203, 0.15), transparent 60%), radial-gradient(1000px 400px at 100% 10%, rgba(230, 230, 250, 0.2), transparent 50%), linear-gradient(180deg, #fff, #faf7fb 60%, #ffffff)",
        }}
      >
        {/* soft circles */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            pointerEvents: "none",
            "&::before, &::after": {
              content: '""',
              position: "absolute",
              width: 420,
              height: 420,
              borderRadius: "50%",
              filter: "blur(48px)",
              opacity: 0.35,
            },
            "&::before": {
              top: -80,
              left: -80,
              background: "linear-gradient(135deg,#f6d1e3,#f2e6ff)",
            },
            "&::after": {
              bottom: -120,
              right: -120,
              background: "linear-gradient(135deg,#e6ddff,#ffe3ef)",
            },
          }}
        />
        <Container maxWidth="lg" sx={{ position: "relative" }}>
          <Stack spacing={2} sx={{ textAlign: "center" }}>
            <Chip
              label="Where elegance meets intelligence"
              color="default"
              sx={{
                alignSelf: "center",
                bgcolor: "rgba(0,0,0,0.03)",
                borderColor: "divider",
              }}
              variant="outlined"
              size="small"
            />
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                letterSpacing: { xs: 0, md: 0.2 },
                lineHeight: 1.15,
                fontSize:'2.25rem'
              }}
            >
              About <Box component="span" sx={{ color: "primary.main" }}>Cosmeti</Box>Compare
            </Typography>
            <Typography
              color="text.secondary"
              sx={{ maxWidth: 840, mx: "auto", fontSize: { xs: 15, sm: 16 } }}
            >
              We help you discover beauty products with clarity and confidence—
              comparing across brands, prices, and ingredients, with a touch of
              luxury in every interaction.
            </Typography>
          </Stack>

          {/* Hero stats / highlights */}
          {/* <Grid container spacing={2} sx={{ mt: 4 }}>
            {[
              { icon: <InsightsRoundedIcon />, label: "Data‑driven comparisons" },
              { icon: <ShieldRoundedIcon />, label: "Transparent insights" },
              { icon: <AutoFixHighRoundedIcon />, label: "Curated elegance" },
            ].map((item, i) => (
              <Grid key={i} item xs={12} sm={4}>
                <Card
                  elevation={0}
                  sx={{
                    backdropFilter: "blur(6px)",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 3,
                  }}
                >
                  <CardContent sx={{ py: 2.5 }}>
                    <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                      <Avatar
                        sx={{
                          bgcolor: "primary.main",
                          color: "primary.contrastText",
                          width: 32,
                          height: 32,
                        }}
                      >
                        {item.icon}
                      </Avatar>
                      <Typography fontWeight={600}>{item.label}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid> */}
        </Container>
      </Box>

      {/* Vision — quoted block with luxe feel */}
      <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "background.default" }}>
        <Container maxWidth="md">
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ display: "block", textAlign: "center", letterSpacing: 1 }}
          >
            Our Vision
          </Typography>
          <Card
            elevation={0}
            sx={{
              mt: 2,
              p: { xs: 3, sm: 4, md: 5 },
              borderRadius: 4,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.8), rgba(255,255,255,0.6))",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                lineHeight: 1.5,
                textAlign: "center",
                fontStyle: "italic",
              }}
            >
              “To become the most trusted and refined destination for beauty product discovery,
              where elegance meets intelligence. We envision a world where every individual can
              confidently choose cosmetics that enhance their unique essence—guided by transparency,
              innovation, and a touch of luxury. At CosmetiCompare, we aspire to redefine the online
              beauty experience—making it effortlessly exquisite.”
            </Typography>
          </Card>
        </Container>
      </Box>

      {/* What we do — three refined pillars */}
      {/* <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "#fff" }}>
        <Container maxWidth="lg">
          <Stack spacing={1} sx={{ textAlign: "center", mb: { xs: 3, md: 5 } }}>
            <Typography variant="overline" color="text.secondary">What we do</Typography>
            <Typography variant="h4" fontWeight={800}>Beauty, compared—beautifully</Typography>
            <Typography color="text.secondary" sx={{ maxWidth: 840, mx: "auto" }}>
              We combine curated taste with transparent data so you can choose what truly fits—your
              skin, your style, your budget.
            </Typography>
          </Stack>

          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {[
              {
                title: "Compare smarter",
                desc:
                  "Side‑by‑side product comparisons across brands, prices, ratings, and key ingredients—so you don’t have to open 10 tabs.",
                points: ["Honest pros & cons", "Ingredient callouts", "Price & value snapshot"],
                icon: <InsightsRoundedIcon />,
              },
              {
                title: "Curated with taste",
                desc:
                  "We spotlight well‑made, well‑reviewed products and limited luxury picks—minus the hype, plus substance.",
                points: ["Editor shortlists", "Occasion‑based picks", "Seasonal essentials"],
                icon: <StarRoundedIcon />,
              },
              {
                title: "Personal & transparent",
                desc:
                  "Filters that matter (finish, coverage, undertone), and clear disclosures on affiliates so you always know how we operate.",
                points: ["Smart filters", "No hidden agenda", "Real user signals"],
                icon: <ShieldRoundedIcon />,
              },
            ].map((card, i) => (
              <Grid key={i} item xs={12} md={4}>
                <Card
                  elevation={1}
                  sx={{
                    height: "100%",
                    borderRadius: 4,
                    p: 0.5,
                    background:
                      "linear-gradient(135deg, rgba(246, 209, 227, 0.35), rgba(230, 221, 255, 0.35))",
                  }}
                >
                  <CardContent
                    sx={{
                      p: { xs: 2.5, sm: 3 },
                      bgcolor: "#fff",
                      borderRadius: 3,
                      height: "100%",
                    }}
                  >
                    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
                      <Avatar sx={{ bgcolor: "text.primary", color: "background.paper" }}>
                        {card.icon}
                      </Avatar>
                      <Typography variant="h6" fontWeight={700}>{card.title}</Typography>
                    </Stack>
                    <Typography color="text.secondary" sx={{ mb: 2 }}>{card.desc}</Typography>
                    <Stack spacing={1}>
                      {card.points.map((p, idx) => (
                        <Stack key={idx} direction="row" spacing={1} alignItems="center">
                          <CheckCircleRoundedIcon color="primary" fontSize="small" />
                          <Typography variant="body2">{p}</Typography>
                        </Stack>
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}

      {/* How it works — elegant 3‑step ribbon */}
      <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "background.default" }}>
        <Container maxWidth="lg">
          <Stack spacing={1} sx={{ textAlign: "center", mb: { xs: 3, md: 5 } }}>
            <Typography variant="overline" color="text.secondary">How it works</Typography>
            <Typography variant="h4" fontWeight={800}>From search to signature look</Typography>
          </Stack>

          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            {[
              {
                step: "01",
                title: "Search & discover",
                text: "Find products by brand, budget, finish, coverage, undertone, and more.",
              },
              {
                step: "02",
                title: "Compare clearly",
                text: "Evaluate side‑by‑side: price, rating, ingredients, pros/cons, and value.",
              },
              {
                step: "03",
                title: "Choose confidently",
                text: "Follow curated picks or personalize with filters—buy where it suits you.",
              },
            ].map((s, i) => (
              <Grid key={i} item xs={12} md={4}>
                <Card
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    border: "1px solid",
                    borderColor: "divider",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.9), rgba(255,255,255,0.75))",
                    height: "100%",
                  }}
                >
                  <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                    <Stack spacing={1.5}>
                      <Chip
                        label={s.step}
                        color="primary"
                        variant="filled"
                        sx={{ alignSelf: "flex-start", borderRadius: 2 }}
                        size="small"
                      />
                      <Typography variant="h6" fontWeight={700}>{s.title}</Typography>
                      <Typography color="text.secondary">{s.text}</Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          <Stack direction="row" spacing={1} justifyContent="center" sx={{ mt: 4 }}>
            <IconButton color="primary"><FavoriteBorderRoundedIcon /></IconButton>
            <IconButton color="primary"><BoltRoundedIcon /></IconButton>
            <IconButton color="primary"><AutoFixHighRoundedIcon /></IconButton>
          </Stack>
        </Container>
      </Box>

      {/* Values — short, luxe & human */}
      <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "#fff" }}>
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} alignItems="stretch">
            <Grid item xs={12} md={6}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  p: { xs: 3, md: 4 },
                  borderRadius: 4,
                  border: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="overline" color="text.secondary">Our Promise</Typography>
                <Typography variant="h5" fontWeight={800} sx={{ mt: 1, mb: 1.5 }}>
                  Refinement, transparency, and a touch of luxury.
                </Typography>
                <Typography color="text.secondary">
                  We’re building the internet’s most graceful way to find beauty that truly fits.
                  No noise, no pressure—just clarity wrapped in elegant design.
                </Typography>
                <Divider sx={{ my: 3 }} />
                <Stack spacing={1.2}>
                  {[
                    "Clear disclosures on affiliates and sourcing",
                    "Real signals: ratings, reviews & ingredient callouts",
                    "Editorial taste plus fair comparison data",
                    "Mobile‑first, inclusive experience",
                  ].map((v, i) => (
                    <Stack key={i} direction="row" spacing={1} alignItems="center">
                      <CheckCircleRoundedIcon color="primary" fontSize="small" />
                      <Typography variant="body2">{v}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Card>
            </Grid>

            {/* <Grid item xs={12} md={6}>
              <Card
                elevation={0}
                sx={{
                  height: "100%",
                  p: { xs: 3, md: 4 },
                  borderRadius: 4,
                  background:
                    "linear-gradient(135deg, rgba(246,209,227,0.25), rgba(230,221,255,0.3))",
                  border: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="overline" color="text.secondary">For You</Typography>
                <Typography variant="h5" fontWeight={800} sx={{ mt: 1, mb: 1.5 }}>
                  Your unique essence, thoughtfully amplified.
                </Typography>
                <Typography color="text.secondary">
                  Whether you’re a beginner or a connoisseur, CosmetiCompare adapts to your style
                  and budget—so every routine feels a little more “you”.
                </Typography>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 3 }}>
                  <Button
                    variant="contained"
                    endIcon={<ArrowForwardRoundedIcon />}
                    href="/compare"
                  >
                    Start comparing
                  </Button>
                  <Button variant="outlined" href="/faq">Explore FAQs</Button>
                </Stack>
              </Card>
            </Grid> */}
          </Grid>
        </Container>
      </Box>

      {/* Closing CTA */}
      <Box component="section" sx={{ py: { xs: 6, md: 8 }, backgroundColor: "background.default" }}>
        <Container maxWidth="md" sx={{ textAlign: "center" }}>
          <Typography variant="h4" fontWeight={800}>
            Make your next beauty choice—effortlessly exquisite.
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1, mb: 3 }}>
            Compare with clarity. Choose with confidence. Glow with intent.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
            <Button variant="contained" size="large" href="/">Browse products</Button>
            <Button variant="text" size="large" href="/contactus">Talk to us</Button>
          </Stack>
        </Container>
      </Box>
    </Fragment>
  );
}
